// extracted by mini-css-extract-plugin
export default {"wrap":"Todos_wrap__n-27M"};